import { FC, PropsWithChildren, ReactNode } from 'react'

import styled from 'styled-components'

export type PrimaryLabelProps = PropsWithChildren<{
  text: ReactNode
  className?: string
}>

const Container = styled.div`
  display: inline-flex;
  height: 24px;
  padding: 0px 6px;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 16px;
  background: ${({ theme }) => theme.color.lightGrey};
  overflow: hidden;
  color: ${({ theme }) => theme.color.darkGrey};
  text-overflow: ellipsis;

  font-family: 'Segoe UI';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
export const PrimaryLabel: FC<PrimaryLabelProps> = ({
  text,
  className,
  children,
}) => (
  <Container className={className}>
    {children}
    <span>{text}</span>
  </Container>
)
